export default function getCurrentMediaId({ state }) {
  const mediaPath = state.get('media.currentFile')
  const media = state.get(mediaPath)
  const selectedFiles = state.get('media.selectedFiles')
  return {
    id: media.id,
    viewIndex: selectedFiles.indexOf(media.id)
  }
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/getCurrentMediaId.js